// Save a Blob to disk. Previously duplicated in taxonomy-generator/txApi.js and
// inlined again in DataDictionaryPage; both now import this.
export function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
